import type { DocNetInboxItem } from 'src/@types/docnet';

export const mockInboxItems: DocNetInboxItem[] = [
  {
    id: 'inbox-001',
    type: 'approval',
    status: 'pending',
    title: 'Approve high-value vanilla extract invoice (EUR 87,500)',
    description: 'Invoice from Bourbon Vanilla Exports for 250kg high-grade vanilla extract. Total EUR 87,500 exceeds auto-approval threshold. APReviewer verified lot numbers and supplier contract pricing.',
    issue_id: 'task-004',
    issue_title: 'Review high-value vanilla extract invoice INV-BV-2026-0448 (EUR 87,500)',
    agent_id: 'agent-005',
    agent_name: 'APReviewer',
    requested_by_id: 'agent-005',
    requested_by_name: 'APReviewer',
    created_on: '2026-03-09T07:55:00Z',
  },
  {
    id: 'inbox-002',
    type: 'escalation',
    status: 'pending',
    title: 'Allergen mismatch detected on cocoa shipment',
    description: 'CoA for Cacao Tropicale batch #CT-88712 declares "May contain MILK" but product spec requires milk-free. ComplianceValidator flagged for immediate review before goods receipt release.',
    issue_id: 'task-002',
    issue_title: 'Cross-check allergen declarations against product specs',
    agent_id: 'agent-003',
    agent_name: 'ComplianceValidator',
    requested_by_id: 'agent-003',
    requested_by_name: 'ComplianceValidator',
    created_on: '2026-03-09T08:35:00Z',
  },
  {
    id: 'inbox-003',
    type: 'question',
    status: 'pending',
    title: 'Partial delivery — accept 80% of cocoa butter order?',
    description: 'Invoice from Cacao Tropicale for 5,000kg cocoa butter matches PO but goods receipt shows only 4,000kg delivered. Accept partial match (EUR 32,000 of EUR 40,000) or hold until remaining 1,000kg arrives?',
    issue_id: 'task-006',
    issue_title: 'Match cocoa butter invoice to PO and goods receipt',
    agent_id: 'agent-004',
    agent_name: 'POMatchingAgent',
    requested_by_id: 'agent-004',
    requested_by_name: 'POMatchingAgent',
    created_on: '2026-03-09T08:32:00Z',
  },
  {
    id: 'inbox-004',
    type: 'approval',
    status: 'pending',
    title: 'Approve new organic spice supplier in Infor LN',
    description: 'Anatolian Spice Trading — all food safety documents validated. FSSC 22000 certificate verified (expires 2027-08). Allergen policy reviewed. Ready to create vendor master in Infor LN.',
    issue_id: 'task-011',
    issue_title: 'Onboard new organic spice supplier: Anatolian Spice Trading',
    agent_id: 'agent-006',
    agent_name: 'SupplierOnboarder',
    requested_by_id: 'agent-006',
    requested_by_name: 'SupplierOnboarder',
    created_on: '2026-03-08T15:30:00Z',
  },
  {
    id: 'inbox-005',
    type: 'escalation',
    status: 'pending',
    title: 'Pricing dispute: bulk sugar contract with Loire Valley Organics',
    description: 'Loire Valley Organics claims invoice should be EUR 45,000 not EUR 42,300. References contract clause 4.2 for annual organic premium adjustment. Needs procurement review.',
    issue_id: 'task-019',
    issue_title: 'Escalation: Loire Valley Organics disputing sugar invoice amount',
    agent_id: undefined,
    agent_name: undefined,
    requested_by_id: 'user-002',
    requested_by_name: 'Sarah Mueller',
    created_on: '2026-03-09T08:30:00Z',
  },
  {
    id: 'inbox-006',
    type: 'review',
    status: 'pending',
    title: 'Review translated olive oil supply contract (IT→EN)',
    description: 'Mediterranean Olive Co. contract translated (96.8% confidence). 3 terms flagged for legal review: "penale contrattuale", "clausola risolutiva espressa", "olio extra vergine di prima spremitura".',
    issue_id: 'task-014',
    issue_title: 'Translate Italian olive oil supply contract',
    agent_id: 'agent-008',
    agent_name: 'TranslationAgent',
    requested_by_id: 'agent-008',
    requested_by_name: 'TranslationAgent',
    created_on: '2026-03-05T14:10:00Z',
  },
  {
    id: 'inbox-007',
    type: 'notification',
    status: 'resolved',
    title: 'Pipeline health report: All systems nominal',
    description: 'Daily pipeline health: 98.2% success rate, avg processing time 4.3s, 0 SLA breaches. 47 supplier documents processed in last 24h across 6 ingredient vendors.',
    issue_id: 'task-007',
    issue_title: 'Monitor daily processing pipeline health',
    agent_id: 'agent-007',
    agent_name: 'ProcessOrchestrator',
    requested_by_id: 'agent-007',
    requested_by_name: 'ProcessOrchestrator',
    created_on: '2026-03-09T06:00:00Z',
    acted_at: '2026-03-09T08:00:00Z',
  },
  {
    id: 'inbox-008',
    type: 'approval',
    status: 'resolved',
    title: 'Approve duplicate invoice rejection: Alpenland Dairy INV-AD-4401-R',
    description: 'Confirmed duplicate of INV-AD-4401 from Alpenland Dairy AG (same amount EUR 24,600, same date, same PO for milk powder delivery). Recommend rejection.',
    issue_id: 'task-009',
    issue_title: 'Review duplicate dairy invoice detection results',
    agent_id: 'agent-005',
    agent_name: 'APReviewer',
    requested_by_id: 'agent-005',
    requested_by_name: 'APReviewer',
    created_on: '2026-03-08T10:05:00Z',
    acted_at: '2026-03-08T11:30:00Z',
    resolution_notes: 'Confirmed duplicate — rejected per policy.',
  },
  {
    id: 'inbox-009',
    type: 'question',
    status: 'pending',
    title: 'Missing PO for Pacific Coast Ingredients invoice: create or reject?',
    description: 'Invoice EUR 14,200 from Pacific Coast Ingredients for natural colorings has no matching PO. Options: (1) Create retroactive PO, (2) Route to procurement, (3) Reject back to supplier.',
    issue_id: 'task-010',
    issue_title: 'Resolve PO matching discrepancy for Pacific Coast Ingredients',
    agent_id: 'agent-004',
    agent_name: 'POMatchingAgent',
    requested_by_id: 'agent-004',
    requested_by_name: 'POMatchingAgent',
    created_on: '2026-03-09T08:05:00Z',
  },
  {
    id: 'inbox-010',
    type: 'notification',
    status: 'dismissed',
    title: 'Classification batch complete: 38 supplier documents routed',
    description: 'Morning email batch processed: 18 invoices, 8 CoAs, 5 delivery notes, 4 PO confirmations, 2 organic certificates, 1 contract. All routed to respective pipelines.',
    issue_id: 'task-016',
    issue_title: 'Classify and route 38 supplier documents from shared inbox',
    agent_id: 'agent-002',
    agent_name: 'DocClassifier',
    requested_by_id: 'agent-002',
    requested_by_name: 'DocClassifier',
    created_on: '2026-03-09T07:46:00Z',
    acted_at: '2026-03-09T08:10:00Z',
  },
  {
    id: 'inbox-011',
    type: 'escalation',
    status: 'pending',
    title: 'FSSC 22000 certificate expires in 30 days — ClearPack Industries',
    description: 'ComplianceValidator detected that packaging supplier ClearPack Industries\' FSSC 22000 certificate expires on 2026-04-08. Current orders in pipeline. Needs renewal confirmation before next PO.',
    issue_id: 'task-012',
    issue_title: 'Flag expired FSSC 22000 certificate for ClearPack Industries',
    agent_id: 'agent-003',
    agent_name: 'ComplianceValidator',
    requested_by_id: 'user-001',
    requested_by_name: 'Amier Haider',
    created_on: '2026-03-09T07:35:00Z',
  },
  {
    id: 'inbox-012',
    type: 'approval',
    status: 'pending',
    title: 'Approve credit note for rejected dairy batch',
    description: 'Alpenland Dairy AG credit note CN-AD-2026-0087 for EUR 8,400. Batch #AD-L-20260215 failed microbiological test (elevated coliform count). Credit note matches original invoice. Ready for posting.',
    issue_id: 'task-015',
    issue_title: 'Process credit note for rejected Alpenland Dairy batch',
    agent_id: 'agent-003',
    agent_name: 'ComplianceValidator',
    requested_by_id: 'agent-003',
    requested_by_name: 'ComplianceValidator',
    created_on: '2026-03-09T07:05:00Z',
  },
] as DocNetInboxItem[];
